export const ERROR_WHITELIST = {
    code: true,
    message: true,
    name: true,
    status: true,
    config: false,
    stack: false,
    request: false,
    response: {
        status: true,
        data: true,
        statusText: true,
        headers: false,
        config: false,
        request: false
    }
};
